import { FC } from 'react';
import { Spinner } from '@pfizer/shared/components';
import type { SpinnerProps } from '@pfizer/shared/components';

interface LoadingWheelProps {
  size: number;
  className?: string;
}

/**
 * LoadingWheel - Adapter component that wraps the shared Spinner for backward compatibility.
 * Maps numeric size to closest Spinner size variant.
 */
const LoadingWheel: FC<LoadingWheelProps> = ({ size, className }) => {
  // Map numeric size to Spinner size variant
  const getSizeVariant = (numericSize: number): SpinnerProps['size'] => {
    if (numericSize <= 16) return 'sm';
    if (numericSize <= 24) return 'md';
    if (numericSize <= 32) return 'lg';
    return 'xl';
  };

  return <Spinner size={getSizeVariant(size)} className={className} />;
};

export default LoadingWheel;
